import { render, staticRenderFns } from "./TwoPhoto.vue?vue&type=template&id=43833f5c&scoped=true"
import script from "./TwoPhoto.vue?vue&type=script&lang=js"
export * from "./TwoPhoto.vue?vue&type=script&lang=js"
import style0 from "./TwoPhoto.vue?vue&type=style&index=0&id=43833f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43833f5c",
  null
  
)

export default component.exports